// Third Party
import * as React from 'react';

// Utils
import { categorizeAndSortFeatures } from './amenities-selection/categorize-and-sort-features';
import { FeatureKey } from '@gql';

// UI
import { Typography } from '@components/typography';
import { Button } from '@components/button';
import { Icon, IconNames } from '@components/icon';

export type Feature = {
  key: FeatureKey;
  displayName: string;
  categoryName: string;
  promoted: boolean;
};

type Props = {
  allFeatures: Feature[];
  currentActiveFeatures: Feature[];
  toggleFeatureFilter: (featureFilter: Feature) => void;
};

export const AmenitiesSelection: React.FC<Props> = ({
  allFeatures,
  currentActiveFeatures,
  toggleFeatureFilter,
}) => {
  const [showAllEnabled, setShowAllEnabled] = React.useState<boolean>(false);

  return (
    <div>
      {categorizeAndSortFeatures(allFeatures).map((category, index) => {
        if (!showAllEnabled) {
          if (category.label !== 'Popular') {
            return false;
          }
        }
        return (
          <div key={index} className="my-2">
            {showAllEnabled && (
              <Typography
                variant="subtitle2"
                variantM="subtitle1"
                component="h4"
                className="mb-2 mt-4 !tracking-normal text-primary-light"
              >
                {category.label}
              </Typography>
            )}
            <div className="mt-4 grid grid-cols-1 gap-x-8 lg:grid-cols-2 lg:gap-x-16">
              {category.features.map((feature, index) => {
                if (!showAllEnabled) {
                  if (index > 16) return false;
                }

                return (
                  <div key={index}>
                    <label
                      htmlFor={feature.displayName}
                      className="flex items-center justify-between font-semibold text-primary-main hover:cursor-pointer"
                    >
                      {feature.displayName}
                      <input
                        id={feature.displayName}
                        type="checkbox"
                        className="my-2 mr-2 flex h-5 w-5 items-center border-2 border-primary-main accent-primary-main transition duration-150 ease-in-out"
                        onClick={() => toggleFeatureFilter(feature)}
                        checked={currentActiveFeatures.includes(feature)}
                      />
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}

      <div className="flex flex-row justify-center">
        <Button
          variant="text"
          color="primary"
          size="md"
          onClick={() => setShowAllEnabled(!showAllEnabled)}
          className="hover:text-secondary-dark"
        >
          <Icon
            className="pr-2"
            name={
              !showAllEnabled ? IconNames.CHEVRON_DOWN : IconNames.CHEVRON_UP
            }
          />
          {!showAllEnabled ? 'see more' : 'see less'}
        </Button>
      </div>
    </div>
  );
};
